import { LogicalErrorDocumentType } from 'app/shared/constants/logical-error-document-type';
import { Params } from '@angular/router';

export const REMEDIATION_ROUTE = {
  DEFAULT: '',
  DOCUMENT: {
    name: ':documentType',
    queryParams(classId: string): Params {
      return { ClassId: encodeURI(classId) };
    },
    route(logicalErrorId: string, documentType: LogicalErrorDocumentType): string[] {
      return [...REMEDIATION_ROUTE.route(logicalErrorId), documentType];
    }
  },
  name: 'remediation/:logicalErrorId',
  REMEDIATION: {
    name: 'remediation/:logicalErrorId',
    route(logicalErrorId: string): string[] {
      return ['/remediation', logicalErrorId];
    }
  },
  REMEDIATION_DOCUMENT: {
    name: 'remediation/:logicalErrorId/:documentType',
    queryParams(classId: string): Params {
      return { ClassId: encodeURI(classId) };
    },
    route(logicalErrorId: string, documentType: LogicalErrorDocumentType): string[] {
      return ['/remediation', logicalErrorId, documentType];
    }
  },
  route(logicalErrorId: string): string[] {
    return ['/remediation', logicalErrorId];
  },
};

